import React, { useState } from "react";
import { Session } from "../../../../Entities/Session";
import { Button, Divider, Modal, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

interface JobApplicationinterviewRoundsScreenRecordingModalProps {
  show: boolean;
  onClose: () => void;
  selectedSession: Session;
  roundName: string;
}

const JobApplicationinterviewRoundsScreenRecordingModal: React.FC<
  JobApplicationinterviewRoundsScreenRecordingModalProps
> = ({ show, onClose, selectedSession, roundName }) => {
  const { screenRecordingLink } = selectedSession;
  const [videoError, setVideoError] = useState(false);

  if (!screenRecordingLink || screenRecordingLink.trim() === "") {
    return null;
  }
  return (
    <Modal
      open={show}
      onCancel={onClose}
      destroyOnClose={true}
      title={null}
      footer={null}
      centered
      closeIcon={null}
    >
      <div className="job-application-interview-rounds-modal-container">
        <Typography.Title level={5} style={{ margin: 0 }}>
          Screen Recording - {roundName}
        </Typography.Title>
        <Divider style={{ margin: 0 }} />

        {videoError ? (
          <div style={{ padding: 24, textAlign: "center", background: "var(--ant-color-fill-quaternary)", borderRadius: 8 }}>
            <Typography.Text type="secondary">
              This recording cannot be played. The format may not be supported or the source is unavailable.
            </Typography.Text>
          </div>
        ) : (
          <video
            controls
            autoPlay
            loop
            onError={() => setVideoError(true)}
            style={{ width: "100%" }}
          >
            <source src={screenRecordingLink} type="video/mp4" />
            <source src={screenRecordingLink} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        )}

        <div className="job-application-interview-rounds-modal-footer">
          <Button icon={<CloseOutlined />} type="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default JobApplicationinterviewRoundsScreenRecordingModal;
